// extracted by mini-css-extract-plugin
export var actionButton = "_a5-0";
export var attachmentLine = "_a5-1";
export var fileInput = "_a5-2";
export var fileUploadWrapper = "_a5-4";
export var footer = "_a5-3";
export var modalContent = "_a5-5";
export var paperclip = "_a5-6";
export var quillEditor = "_a5-7";